module.exports = __webpack_public_path__ + "c31cf949d67cb24f3c7792ed2a845950.svg";